"use strict";
exports.__esModule = true;
exports.Numbers = void 0;
var between = function (value, min, max) { return min <= value && max >= value; };
exports.Numbers = {
    between: between
};
//# sourceMappingURL=numbers.js.map